<template>
    <div>
      <AdminViewPR/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import AdminViewPR from '@/components/AdminViewPR.vue'
  
  export default {
    name: 'pr-summary',
    components: {
      AdminViewPR
    }
  }
  </script>
  